import React from 'react'
import AdministrativeInsertion from './AdministrativeInsertion'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { patientActions } from '../../../../redux/patient/index'
import Patient from '../../../../models/Patient/Patient'
import { currentSelectionActions } from '../../../../redux/currentSelection/index'

class AdministrativeInsertionContainer extends React.Component {
  render () {
    const {immunizations, selectPreviousInsertion, removePatient, patient, selectPatient, match} = this.props
    return <AdministrativeInsertion
      match={match}
      immunizations={immunizations}
      selectPreviousInsertion={selectPreviousInsertion}
      removePatient={removePatient}
      patient={patient}
      selectPatient={selectPatient} />
  }
}

function mapStateToProps (state) {
  const {patient, immunizations} = state
  if (patient.data) {
    const {id, name, birthDate, gender, photo, country} = patient.data
    return {
      immunizations,
      patient: new Patient(id, name, birthDate, gender, photo, country)
    }
  }
  return {}
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({...patientActions, ...currentSelectionActions}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AdministrativeInsertionContainer)
